import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Location from "/Location.png?url";

const getFormattedDate = (date) => {
  const dayNames = [
    "อาทิตย์",
    "จันทร์",
    "อังคาร",
    "พุธ",
    "พฤหัสบดี",
    "ศุกร์",
    "เสาร์",
  ];
  const day = dayNames[date.getDay()];
  const formattedDateOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  const formattedDate = date.toLocaleString("th-TH", formattedDateOptions);
  return `วัน${day}ที่ ${formattedDate}`;
};

const getCurrentFormattedTime = () => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes} น.`;
};

const Clock = () => {
  const location = useLocation();
  const [selectedBranch, setSelectedBranch] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const branch = sessionStorage.getItem("selectedBranch");
    if (branch) {
      setSelectedBranch(branch);
    }

    const intervalId = setInterval(() => {
      const now = new Date();
      setCurrentDate(getFormattedDate(now));
      setCurrentTime(getCurrentFormattedTime());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div>
      <h3>
        {location.pathname === "/dashboard" && <>{`📍 ${selectedBranch} | `}</>}
        {currentDate} | {currentTime}
      </h3>
    </div>
  );
};

export default Clock;
